module.exports = __webpack_public_path__ + "static/media/action_required.46baa6ea.png";